import { SELECT_CURRENT_ACCOUNT_DATA } from '../types';

export default (state = null, action) => {
  switch (action.type) {
    case SELECT_CURRENT_ACCOUNT_DATA:
      return action.payload
    default:
      return state;
  }
}